import type { LeadPropertyAddress } from '@/modules/leads/leadApi';
import type { Lead } from '@/types';

export interface ClientInfo {
    clientName: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    email: string;
    phone: string;
    folio: string;
    yearBuilt: string;
    propertyType: string;
}

export function applyLeadToClientInfo(
    lead: Lead,
    propertyAddress: LeadPropertyAddress,
    prev: ClientInfo,
): ClientInfo {
    const state = (propertyAddress.state || '').trim();
    return {
        ...prev,
        clientName: (lead.name || '').trim(),
        email: (lead.email || '').trim(),
        phone: (lead.phone_number || '').trim(),
        address: (propertyAddress.address || '').trim(),
        city: (propertyAddress.city || '').trim(),
        state: state || prev.state,
        zipCode: (propertyAddress.zip_code || '').trim(),
    };
}
